import ApplicationCase from './ApplicationCase'
import replyCase from './replyCase'
import Copywriting from './Copywriting'
import ProxyPayment from './ProxyPayment'
import middleCase from './middleCase'
export default [
    {
        name: 'ApplicationCase',
        path: 'ApplicationCase',
        component: () => import('@/pages/BigData/PatentModule/ApplicationCase'),
        meta: { title: '专利【申请案件】申报', requiresAuth: true },
        props(route) {
            return {
                id: route.query.id,

            }
        },
        children:[...ApplicationCase]
    },
    {
        name: 'middleCase',
        path: 'middleCase',
        redirect:{name:'middleAll'},
        component: () => import('@/pages/BigData/PatentModule/middleCase'),
        meta: { title: '专利【中间案件】申报' },
        props(route) {
            return {id: route.query.id}
        },
        children:[...middleCase]
    },
    {
        name: 'replyCase',
        path: 'replyCase',
        redirect: { name: 'reqAll' },
        component: () => import('@/pages/BigData/PatentModule/replyCase'),
        meta: { title: '专利 【答辩/复审案件】申报' },
        props(route) {
            return {id: route.query.id}
        },
        children:[...replyCase]
    },
    {
        name: 'Copywriting',
        path: 'Copywriting',
        redirect: { name: 'waAll' },
        component: () => import('@/pages/BigData/PatentModule/Copywriting/index'),
        meta: { title: '专利【文案】撰写/翻译' },
        props(route) {
            return {
                id: route.query.id,
            }
        },
        children:[...Copywriting]
    },
    {
        name: 'ProxyPayment',
        path: 'ProxyPayment',
        redirect: { name: 'prAll' },
        component: () => import('@/pages/BigData/PatentModule/ProxyPayment/index'),
        meta: { title: '专利【费用】代缴' },
        props(route) {
            return {
                id: route.query.id,
            }
        },
        children:[...ProxyPayment]
    },
]